import { ComponentStyleConfig } from '@chakra-ui/react';
import { getColor, mode, StyleFunctionProps } from '@chakra-ui/theme-tools';

const multiSegmentFilledTrack = (props: StyleFunctionProps) => {
  const { theme, values, max } = props;

  const breakpoints: string[] = [];
  let totalPct = 0;
  const trackColor = getColor(theme, mode('borderBase', 'borderBase')(props));

  Object.entries(values).forEach(([color, val]) => {
    const fillColor = getColor(
      theme,
      mode(`${color}.500`, `${color}.200`)(props),
      color
    );

    const pct = +Number.parseFloat(
      String((((val as unknown) as number) / max) * 100)
    ).toFixed(1);

    breakpoints.push(`${fillColor} ${totalPct}%`);

    totalPct += pct;
    if (totalPct > max) {
      totalPct = max;
    }

    breakpoints.push(`${fillColor} ${totalPct}%`);
  });

  if (totalPct < max) {
    breakpoints.push(`${trackColor} ${totalPct}%`);
    breakpoints.push(`${trackColor} 100%`);
  }

  const gradient = `
    linear-gradient(
    to right,
    ${breakpoints.join(', ')}
  )`;

  // Need to override the width specified by style
  return {
    minWidth: '100%',
    bgImage: gradient,
  };
};

export const Progress: ComponentStyleConfig = {
  variants: {
    multiSegment: (props) => ({
      filledTrack: multiSegmentFilledTrack(props),
    }),
  },
};
